module.exports = __webpack_public_path__ + "img/11.c32a7934.jpg";